import * as React from 'react';
import { certificationIconSize, tooltipSize, tooltipStyle } from '../common/Style';
import { ChromeTooltipWidget } from './ChromeTooltip/ChromeTooltipWidget';
import { DataConnectionIconComponent } from './DataConnectionIcon';
import { DataConnectionListComponent } from './DataConnectionList';
import { DataConnectionRowProps } from './DataConnectionRow';
import { generateId, Id } from '../common/Id';
import { Messages } from '../../gen-src/Localize';

// Extra space between certification icon and other in-line content
const space = 4;

const contentStyle: React.CSSProperties = {
  ...tooltipStyle,
  marginTop: space,
  marginBottom: space,
  marginRight: space,
  marginLeft: -1 * space
};

const dataConnectionIconStyle: React.CSSProperties = {
  verticalAlign: 'text-bottom'
};

const contentHeaderStyle: React.CSSProperties = {
  fontWeight: 'bold',
  marginLeft: certificationIconSize
};

const contentFooterStyle: React.CSSProperties = {
  textAlign: 'right'
};

const linkStyle: React.CSSProperties = {
  color: '2A79AF'
};

/**
 * Test id attribute value (prefix) for content of data connection tooltip component.
 */
export const dataConnectionTooltipTestId: Id = 'data-connection-tooltip';

/**
 * Type synonym for data connection model.
 */
export type DataConnection = DataConnectionRowProps;

/**
 * Props for data connection tooltip component.
 */
export interface DataConnectionTooltipProps {
  dataConnections: DataConnection[];
  url: string;
  id?: Id;
  boundaryElement?: HTMLElement;
  // TODO remove after unifying stacking strategy in viz client, see feature 579115
  zIndex?: number;
  label?: string;
}

/**
 * Data connection tooltip component.
 * @param props - The props for this data connection tooltip.
 */
export function DataConnectionTooltipComponent(props: DataConnectionTooltipProps): React.ReactElement<DataConnectionTooltipProps> {
  // NOTE this function could make an AJAX request
  const getContent = () => Promise.resolve(<DataConnectionTooltipComponentContent {...props} />);
  return (
    <span>
      <ChromeTooltipWidget
        getContent={getContent}
        width={tooltipSize}
        defaultSide='Bottom'
        boundaryElement={props.boundaryElement}
        zIndex={props.zIndex}
      >
        <DataConnectionIconComponent style={dataConnectionIconStyle} id={props.id} />
      </ChromeTooltipWidget>
      {props.label || props.dataConnections.length}
    </span>
  );
}

export function DataConnectionTooltipComponentContent({ dataConnections, url, id }: DataConnectionTooltipProps)
  : React.ReactElement<DataConnectionTooltipProps> {
  return (
    <div data-tb-test-id={generateId(dataConnectionTooltipTestId, id)} style={contentStyle}>
      {dataConnections.length === 0 &&
        <span style={contentHeaderStyle}>
          {Messages.NoDataConnections()}
        </span>
      }
      <DataConnectionListComponent dataConnections={dataConnections} />
      <div style={contentFooterStyle}>
        <a style={linkStyle} href={url}>{Messages.SeeMoreDetails()}</a>
      </div>
    </div>
  );
}
